/**
 * Re-export for app-wide usage outside Sidebar.
 * Tokens: themeColor.* — require `data-theme-color` scope on an ancestor.
 */
export {
  useThemeColorScope,
  useSidebarThemeStore,
  type ThemeColorScopeProps,
  type SidebarThemeId,
} from "@/_components/ui/Sidebar/sidebarTheme";
